import { useState, type ReactNode } from "react";
import * as Styled from "./styled";

type Props = {
  tabs: { id: string; label: ReactNode; content: ReactNode }[];
  onTabChange?: (id: string) => void;
};

const TabbedDisplay = ({ tabs, onTabChange }: Props) => {
  const [currentTabId, setCurrentTabId] = useState(tabs[0]?.id);

  const handleTabChange = (id: string) => {
    if (id === currentTabId) return;

    setCurrentTabId(id);
    onTabChange?.(id);
  };

  return (
    <Styled.TabbedDisplay>
      <Styled.TabSection>
        <Styled.TabsWrapper role="tablist">
          {tabs.map((tab) => (
            <Styled.Tab
              key={tab.id}
              role="tab"
              aria-selected={currentTabId === tab.id}
              tabIndex={currentTabId === tab.id ? 0 : -1}
              $active={currentTabId === tab.id}
              onClick={() => handleTabChange(tab.id)}
            >
              {tab.label}
            </Styled.Tab>
          ))}
        </Styled.TabsWrapper>
      </Styled.TabSection>
      <Styled.ContentSection>
        {tabs.find((tab) => tab.id === currentTabId)?.content}
      </Styled.ContentSection>
    </Styled.TabbedDisplay>
  );
};

export default TabbedDisplay;
